import React, { useEffect } from "react";
import { useSupplyReportStore } from "./stores/supplyReportStore";
import SupplyReportHeader from "./components/SupplyReportHeader/SupplyReportHeader";
import SupplyReportTable from "./components/SupplyReportTable/SupplyReportTable";
import { Loading, PaginationControls } from "components";

// Головний компонент сторінки "Очікуваний прихід"
const SupplyReportPage = () => {
  const totalCount = useSupplyReportStore((state) => state.totalCount);
  const isLoading = useSupplyReportStore((state) => state.isLoading);
  const filters = useSupplyReportStore((state) => state.filters);
  const setPage = useSupplyReportStore((state) => state.setPage);
  const init = useSupplyReportStore((state) => state.init);

  // Ініціалізує дані та фільтри при першому завантаженні сторінки
  useEffect(() => {
    init();
  }, [init]);

  const totalPages = Math.ceil(totalCount / filters.page_size) || 1;

  return (
    <section id="supplyreportpage">
      <div className="page-container">
        <SupplyReportHeader />

        {isLoading ? (
          <Loading />
        ) : (
          <>
            <SupplyReportTable />
            <PaginationControls
              page={filters.page}
              totalPages={totalPages}
              onPageChange={(page) => setPage(page)}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default SupplyReportPage;
